import { Component, OnInit } from '@angular/core';
import {TranslateService} from "../../../services/translate.service";
import {MatChipInputEvent} from "@angular/material/chips";
import {COMMA, ENTER} from "@angular/cdk/keycodes";

export interface Shortcut {
  name: string;
}

@Component({
  selector: 'app-helper',
  templateUrl: './helper.component.html',
  styleUrls: ['./helper.component.css']
})
export class HelperComponent implements OnInit {

  text = 'AHM';

  shortcutsENG_AHM1 = {
    // main concepts AHM1
    "AHM": "Alphabet of the Human Mind",
    "PPM": "Particulary-Primitive type of Mind",
    "AF": "Aggressive Form",
    "DF": "Depressive Form",
    "KF": "Kind Form",
    "MHP": "Mentally Healthy Person",
    "PPJ": "Particullary-Primitive Judgment",
    "THP": "Type of Human Personality",
    "GCJ": "Generally-Complex Judgment",
    "GCM": "Generally-Complex type of Mind",
    "CF": "Closed Form",
    "OF": "Open Form",
    "UA": "Unreasanoble Aggression",
    "UM": "Unreasonable Majesty",
    "UK": "Unreasonable Kindness",
    // secondary classification
    "CT": "Contact Type of PPM",
    "NT": "Noncontact Type of PPM",
    "MCT": "Material Contact Type of PPM",
    "PCT": "Psychic Contact Type of PPM",
    "MNT": "Material Noncontact Type of PPM",
    "PNT": "Psychic Noncontact Type of PPM",
    "AM": "Agressive Mask",
    "DM": "Depressive Mask",
    "KM": "Kind Mask",
    "LI": "Language of Idiots",
    "LPJ": "Language of Primitive Judgments",
    "LPPJ": "Language of PPJs",
    "JLPJ": "Judgment of LPJ",
    "LMHP": "Language of Mentally Healthy People",
    // martix therapy crutches
    "MPPJ": "Matrix of Particulary-Primitive Judgments",
    "OMPPJ": "Old MPPJ",
    "NMPPJ": "New MPPJ",
    "CPO": "Crutches of Public Opinion",
    "SCPO": "Soviet Crutches fo Public Opinion",
    "ECPO": "European Crutches of Public Opinion",
    "TLCPO": "Temporary Loss of CPO",
    "LLCPO": "Long Loss of CPO",
    "PLCPO": "Permanent Loss of CPO",
    "CSP": "Crutches of Sick Psyche",
    "TCPO": "Treatment Crutches of Public Opinion",
    "NPS": "Natural Psyche Supports",
    "MPHS": "Model of Personal Human Space",
    "SMPHS": "Simplified Model of Personal Human Space",
    "TMPHS": "Total Model of Personal Human Space",
    "TCSHP": "Table of Conformity Sick-Healthy Psyche",

    "TNM": "Treatment by Non-violent Methods",
    "SNM": "Submission by Non-violent Methods",
    "TNB": "Treatment Nonviolent Branch",
    "VNB": "Voluntary Nonviolent Branch",
    "TSNB": "Treatment-Submissive Nonviolent Branch",
    "SNB": "Submissive Nonviolent Branch",
    "NP": "Nonviolent AHM Psychotherapy",
    "ENP": "Experimental Nonviolent AHM Psychotherapy",
    "SNP": "Submissive Nonviolent AHM Psychotherapy",
    "TSNP": "Treatment-Submissive Nonviolent AHM Psychotherapy",
    "TNP": "Treatment Nonviolent AHM Psychotherapy",
    "RNP": "Regenerative Nonviolent AHM Psychotherapy",
    "FNP": "Firming Nonviolent AHM Psychotherapy",
    "PPE": "Psychic Persons Energy",
    // other
    "HS": "Hypersensitivity of PPM",
    "SC": "Superiority Complex",
    "WC": "Worm of Conscience",
    "FC": "Fire of Conscience",
    "PS": "Private Space",
    "RI": "Reflex Idiocy",
    "UI": "Unreflection of Idiocy",
    "MDS": "Manic-Depressive Syndrome"
  };

  shortcutsRUS_AHM1 = {
    // main concepts by ABC sequence
    "АМ": "Агрессивная Маска",
    "АФ": "Агрессивная Форма",
    "АЧП": "Азбука Человеческой Психики",
    "БПТ": "Бесконтактный Психический Тип КМП",
    "БТ": "Бесконтактный Тип КПМа",
    "БФТ": "Бесконтактный Физический Тип КМП",
    "ВНП АЧП": "Восстановительная Ненасильственная АЧП Психотерапия",
    "ВПКОМ": "Временная Потеря Костылей Общественного Мнения",
    "ГЧ": "Гиперчувствительность КПМ",
    "ДИ": "Дирефлектация Идиотизма",
    "ДМ": "Депрессивная Маска",
    "ДНО": "Добровольное Ненасильственное Отделение",
    "ЛНО": "Лечебное Ненасильственное Отделение",
    "ДПКОМ": "Длительная Потеря Костылей Общественного Мнения",
    "ДФ": "Депрессивная Форма",
    "ЕКОМ": "Европейские Костыли Общественного Мнения",
    "ЕОП": "Естественные Опоры Психики",
    "ЗФ": "Закрытая Форма душевной болезни",
    "КБП": "Костыли Больной Психики",
    "КОМ": "Костыли Общественного Мнения",
    "КПМ": "Конкретно-Примитивный тип Мышления",
    "КПС": "Конкретно-Примитивное Суждение",
    "КПТ": "Контактный Психический Тип КМП",
    "КТ": "Контактный Тип КПМ",
    "КФТ": "Контактный Физический Тип КМП",
    "ЛКОМ": "Лечебные Костыли Общественного Мнения",
    "ЛНМ": "Лечение Ненасильственными Методами",
    "ЛНП АЧП": "Лечебная Ненасильственная АЧП Психотерапия",
    "ЛП": "Личное Пространство",
    "ЛСНО": "Лечебно-Смирительное Ненасильственное Отделение",
    "ЛСНП": "Лечебно-Смирительная Ненасильственная АЧП Психотерапия",
    "МВ": "Мания Величия",
    "МДС": "Маниакально-Депрессивный Синдром ",
    "МКПС": "Матрица Конкретно-Примитивных Суждений",
    "МЛПЧ": "Модель Личного Пространства Человека",
    "НА": "Необоснованная Агрессия",
    "НВ": "Необоснованное (Необдуманное) Величие",
    "НД": "Необоснованное (Необдуманное) Добро",
    "НМКПС": "Новая МКПС",
    "НП": "Ненасильственная АЧП Психотерапия",
    "ОС": "Огонь Совести",
    "ОСМ": "Обобщенно-Сложный тип Мышления",
    "ОСС": "Обобщенно-Сложное Суждение",
    "ОФ": "Открытая Форма душевной болезни",
    "ПЗЧ": "Психически Здоровый Человек",
    "ПЛНМ": "Психиатрическое Лечение Ненасильственными Методами",
    "ПМЛПЧ": "Полная МЛПЧ",
    "ППКОМ": "Постоянная Потеря Костылей Общественного Мнения",
    "ПЭЧ": "Психическая Энергия Человека",
    "РИ": "Рефлекторный Идиотизм",
    "СКОМ": "Советские Костыли Общественного Мнения",
    "СМ": "Стеническая Маска",
    "СМКПС": "Старая МКПС",
    "СНМ": "Смирение Ненасильственными Методами",
    "СНО": "Смирительное Ненасильственное Отделение",
    "СНП": "Смирительная Ненасильственная АЧП Психотерапия",
    "СФ": "Стеническая Форма",
    "СЯПС": "Суждение Языка Примтивных Суждений",
    "ТЛЧ": "Тип Личности Человека",
    "ТСБЗП": "Таблица Соответствия Больной-Здоровой Психики",
    "УМЛПЧ": "Упрощенная МЛПЧ",
    "УНП": "Укрепляющая Ненасильственная АЧП Психотерапия",
    "ЧС": "Червяк Совести",
    "ЭНП АЧП": "Экспериментальная Ненасильственная АЧП Психотерапия",
    "ЯД": "Язык Душевнобольных",
    "ЯПЗ": "Язык Психически Здоровых Людей",
    "ЯПС": "Язык Примитивных Суждений"
  };


  shortcutsRUS_AHM2 = {
    // main concepts by ABC sequence
    "ПГ": "Психическая Грамотность/Психическая Гигиена",
    "ШОН": "Шкала Объективных Навыков",
    "СВН": "Схемой Вынужденной Необходимости АЧП",
    "ГУ": "График Уважения",
    "ПКПМ": "Полный КПМ",
    "ПНА": "Приступ Необоснованной Агрессии",
    "ДП": "Деструктивная Психотерапия",
    "ОНП": "Ошибочная Ненасильственная Психотерапия",
    "ДНП": "Деструктивная Ненасильственная Психотерапия",
    "ННП": "Нулевая Ненасильственная Психотерапия",
    "ПНП": "Превентивная Ненасильственная Психотерапия",
    "ЗНП": "Запоздалая Ненасильственная Психотерапия",
    // todo: ОНП - кофликт
    "ОСНП": "Остаточная Ненасильственная Психотерапия",
    "ЗЕЛНП": "Зеленая Ненасильственная Психотерапия",
    "СЗ": "Схема Зависти",
    "МПП": "Мировой Производственный Потенциал",
    "ППС": "Производственный Потенциал Системы",
    "ПК": "Психические Костыли",
    "ОА": "Обоснованная Агрессия",
    "ОД": "Обоснованной Добро",
    "ОВ": "Обоснованное Величие",
    "ТОА": "Точка Отсчета Агрессии",
    "ПБ": "Психическая Блокада",
    "ДФД": "Депрессивная Форма Депрессивных (Устойчивый Психотип)",
    "СФД": "Стеническая Форма Депрессивных (Восстанавливающий Психотип)",
    "АФД": "Агрессивная Форма Депрессивных (Травмирующий психотип)",
    "ДФС": "Депрессивная Форма Стенических (Устойчивый Психотип)",
    "СФС": "Стеническая Форма Стенических (Восстанавливающий Психотип)",
    "АФС": "Агрессивная Форма Стенических (Травмирующий Психотип)",
    "ДФА": "Депрессивная Форма Агрессивных (Устойчивый Психотип)",
    "СФА": "Стеническая Форма Агрессивных (Восстанавливающий Психотип)",
    "АФА": "Агрессивная Форма Агрессивных (Травмирующий Психотип)",
    "ЗП": "Здоровая Психика",
    "СЭ": "Страшная Эпидемия",
    "ПМС": "Психушка в Масштабах Страны",
    "ДСА": "Ранее обозначало ПКПМ (deprecated)",
    "ВТЛЧ": "Временно ТЛЧ"
  };

  shortcutsENG_AHM2 = {
    // main concepts by ABC sequence
    "PL": "Psychic Literacy",
    "HP": "Human Psyche",
    "MH": "Mental Health",
    "TPPM": "Total PPM, Temporary PPM",
    "DP": "Destructive Psychotherapy",
    "ENP": "Erroneous Psychotherapy",
    "DNP": "Destructive Psychotherapy,Delayed Psychotherapy",
    "ZNP": "Zero Psychotherapy",
    "PNP": "Preventive Psychotherapy",
    "RNP": "Remaining Psychotherapy",
    "INP": "Intuitive Psychotherapy",
    "GNP": "Green Psychotherapy",
    "SOE": "Scheme Of Envy",
    "SE": "Scheme Of Envy",
    "AUA": "Attack of Unreasonable Aggression,Act of Unreasonable Aggression",
    "AUK": "Attack of Unreasonable Kindness,Act of Unreasonable Kindness",
    "AUM": "Attack of Unreasonable Majesty,Act of Unreasonable Majesty",
    "WPP": "World Production Potential",
    "SPP": "System Production Potential",
    "SP": "Stable Psychotype",
    "RP": "Restorative Psychotype",
    "TP": "Traumatic Psychotype",
    "DFD": "Resistant Psychotype of DF",
    "KFD": "Restorative Psychotype of DF",
    "AFD": "A Traumatic Psychotype of DF",
    "DFK": "Steady psychotype of KF",
    "KFK": "Restorative psychotype of KF",
    "AFK": "A traumatic psychotype of KF",
    "DFA": "Steady Psychotype of AF",
    "KFA": "Restorative Psychotype of AF",
    "AFA": "A traumatic Psychotype of AF",
    "CPT": "Contact Physical Type",
    "HCS": "Hierarchical Classification of Symptoms",
    "BS": "Basic Symptoms",
    "ES": "Elementary Symptoms",
    "CS": "Complex Symptoms",
    "ASP": "Aggression Start Point",
    "PB": "Psychic Blockade, Psychic Battle",
    "EP": "External Perimeter",
    "PP": "Psychic Programming",
    "PS": "Psychic Scenarios",
    "STD": "Sexually Transmitted Diseases",
    "DPDSI": "Diseases of the Psyche During Sexual Intercourse",
    "FP": "Fluent Psychic (Language)",
    "PCS": "Psychohouse on a Country Scale",
    "MPPJ": "Matrix of Particular Primitive Judgements",
    "OMPPJ": "Old Matrix of Particular Primitive Judgements",
    "NMPPJ": "New Matrix of Particular Primitive Judgements",
    "OSS": "AHM Objective System of Skills",
    "ARP": "Aggression Reset Point",
    "RPA": "Relief Point of Aggression",
    "CA": "Corporate Aggression",
    "DSA": "Deprecated (Means TPPM)",
    "TTHP": "Temporary THP",
    "TGCM": "Temporary",
    "RA": "Reasonable Aggression",
    "RK": "Reasonable Kindness",
    "RM": "Reasonable Majesty"
  };


  transcript = '...';

  constructor(private translate: TranslateService) { }

  ngOnInit() {
    this.printing();
  }

  printing() {
    this.transcript = '';
    let resultTranslation: string [] = [];
    const text = this.text.toUpperCase().trim();
    if (null != this.shortcutsENG_AHM1[text] || null != this.shortcutsRUS_AHM1[text] || null != this.shortcutsRUS_AHM2[text] || null != this.shortcutsENG_AHM2[text]) {
      if (null != this.shortcutsRUS_AHM2[text]) {
        resultTranslation.push(this.shortcutsRUS_AHM2[text]);
      }
      if (null != this.shortcutsRUS_AHM1[text]) {
        resultTranslation.push(this.shortcutsRUS_AHM1[text]);
      }
      if (null != this.shortcutsENG_AHM1[text]) {
        resultTranslation.push(this.shortcutsENG_AHM1[text]);
      }
      if (null != this.shortcutsENG_AHM2[text]) {
        resultTranslation.push(this.shortcutsENG_AHM2[text]);
      }

      this.transcript += text + ': ' + resultTranslation.toString().replace(/,/g, ', ');
    } else {
      this.transcript = '...';
    }
  }

  getTranscript(abbriviation) {
    const text = abbriviation.toUpperCase().trim();
    let resultTranslation: string [] = [];
    if (null != this.shortcutsENG_AHM1[text] || null != this.shortcutsRUS_AHM1[text] || null != this.shortcutsRUS_AHM2[text] || null != this.shortcutsENG_AHM2[text]) {
      if (null != this.shortcutsRUS_AHM2[text]) {
        resultTranslation.push(this.shortcutsRUS_AHM2[text]);
      }
      if (null != this.shortcutsRUS_AHM1[text]) {
        resultTranslation.push(this.shortcutsRUS_AHM1[text]);
      }
      if (null != this.shortcutsENG_AHM1[text]) {
        resultTranslation.push(this.shortcutsENG_AHM1[text]);
      }
      if (null != this.shortcutsENG_AHM2[text]) {
        resultTranslation.push(this.shortcutsENG_AHM2[text]);
      }
      return text + ': ' + resultTranslation.toString().replace(/,/g, ', ');
    } else {
      return text + ': ' + 'not found';
    }
  }

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  shortcuts: Shortcut[] = [
    {name: 'AHM'},
    {name: 'PPM'},
    {name: 'PPJ'},
  ];

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.shortcuts.push({name: value.trim()});
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(fruit: Shortcut): void {
    const index = this.shortcuts.indexOf(fruit);

    if (index >= 0) {
      this.shortcuts.splice(index, 1);
    }
  }
}
